import { GROUPS_SORTABLE_FIELDS } from "@components/table/groups/groups-table-constants";
import { FaroCoreApiTypes } from "@stellar/core-api-client";

/** Base props for a group */
export interface BaseGroupProps {
  /** Group entity */
  group: FaroCoreApiTypes.GroupSummaryResponse;
}

/** Base props for group details */
export interface BaseGroupDetailsProps {
  /** Group details entity */
  group: FaroCoreApiTypes.GroupDetailResponse;
}

/** All the possible types for a group */
export type GroupTypes =
  /** Basic information for a group */
  | FaroCoreApiTypes.GroupSummaryResponse

  /** Full details of a group */
  | FaroCoreApiTypes.GroupDetailResponse;

/** Available group sort fields - derived from GROUPS_SORTABLE_FIELDS */
export type GroupsSortField = (typeof GROUPS_SORTABLE_FIELDS)[number];

export const GROUPS_SORT_BY = [
  "name_ascending",
  "name_descending",
  "members_ascending",
  "members_descending",
  "projects_ascending",
  "projects_descending",
  "created_date_ascending",
  "created_date_descending",
] as const;

/** All possible groups sort by values */
export type GroupsSortBy = (typeof GROUPS_SORT_BY)[number];
